import React from 'react'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined'

import { GRAY_900 } from 'constants/styling/theme'

/** Whether a file is a PDF, by its MIME type or, when that is missing, its extension. */
export const isPdfFile = (name?: string, mimeType?: string): boolean =>
  mimeType === 'application/pdf' || /\.pdf$/i.test(name ?? '')

/** The row icon for an uploaded file: a document for a PDF, a photo for anything else. */
export const FileKindIcon: React.FC<{ name?: string; mimeType?: string }> = ({ name, mimeType }) => {
  const Icon = isPdfFile(name, mimeType) ? DescriptionOutlinedIcon : InsertPhotoOutlinedIcon
  return <Icon sx={{ color: GRAY_900, fontSize: 18 }} />
}
